// src/pages/ProfilePage.js - Version corrigée
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../components/Layout";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost/securecontrol-backend";

const ProfilePage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("informations"); // État pour gérer l'onglet actif

  const [userInfo, setUserInfo] = useState({
    id: null,
    prenom: "",
    nom: "",
    email: "",
    phone: "",
    profile: "",
    avatarUrl: null,
  });

  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false
});

  const [passwordError, setPasswordError] = useState("");
  const [serverError, setServerError] = useState("");
  const [loading, setLoading] = useState(true);

  const [avatarUploading, setAvatarUploading] = useState(false);
  const [avatarError, setAvatarError] = useState("");



  // Couleurs de la charte graphique
  const COLORS = {
    primary: '#0B3C5D',     // Bleu Sécurité
    secondary: '#1E88C8',   // Bleu Tech
    accent: '#4FC3F7',      // Bleu Clair
    darkText: '#2E2E2E',    // Gris Foncé
    lightBg: '#F5F7FA',     // Gris Clair
    white: '#FFFFFF',
    danger: '#f44336',
    success: '#4caf50',
    warning: '#ff9800',
    info: '#2196f3'
  };

  const togglePasswordVisibility = (field) => {
  setShowPasswords(prev => ({
    ...prev,
    [field]: !prev[field]
  }));
};

  const getAvatarSrc = () => {
    if (userInfo.avatarUrl && userInfo.avatarUrl.includes('user_')) {
      try {
        const parts = userInfo.avatarUrl.split('/');
        const filename = parts[parts.length - 1];

        if (filename.startsWith('user_')) {
          // URL construite à partir d'API_BASE_URL (configurable via
          // REACT_APP_API_BASE_URL) plutôt que codée en dur sur localhost :
          // en production, l'image 404 silencieusement alors que le message
          // de succès de l'upload s'affiche bien (voir même correctif dans
          // components/Header.js::getAvatarUrl).
          const base = API_BASE_URL.replace(/\/+$/, "");
          return `${base}/uploads/avatars/${filename}`;
        }
      } catch (error) {
        console.error("Erreur construction URL:", error);
      }
    }

    return "/assets/img/utilisateur.png";
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const storedUser = localStorage.getItem("user");

    if (!token || !storedUser) {
      navigate("/login");
      return;
    }

    let currentId = null;
    try {
      const parsed = JSON.parse(storedUser);
      currentId = parsed.id;
    } catch (e) {
      console.error("Erreur parse localStorage.user:", e);
      navigate("/login");
      return;
    }

    const fetchProfile = async () => {
      setLoading(true);
      setServerError("");
      try {
        const url = `${API_BASE_URL.replace(/\/+$/, "")}/users/get.php?id=${encodeURIComponent(currentId)}`;

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data?.success && response.data.user) {
          const u = response.data.user;
          
          let avatarUrl = null;
          if (u.avatar_url || u.avatar_path) {
            const avatarPath = u.avatar_url || u.avatar_path;
            const parts = avatarPath.split('/');
            const filename = parts[parts.length - 1];
            
            if (filename.startsWith('user_')) {
              const base = API_BASE_URL.replace(/\/+$/, "");
              avatarUrl = `${base}/uploads/avatars/${filename}`;
            }
          }
          
          setUserInfo({
            id: u.id_user || u.id,
            prenom: u.prenom_user || u.first_name || u.prenom || "",
            nom: u.nom_user || u.last_name || u.nom || "",
            email: u.email_user || u.email_address || u.email || "",
            phone: u.phone_user || u.phone || "",
            profile: u.profile_user || u.profile || "",
            avatarUrl: avatarUrl,
          });
        } else {
          setServerError(
            response.data?.message || "Impossible de charger le profil."
          );
        }
      } catch (err) {
        console.error("Erreur chargement profil:", err);
        setServerError("Erreur technique lors du chargement du profil.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [navigate]);

  const handleLogout = () => {
    if (window.confirm("Êtes-vous sûr de vouloir vous déconnecter ?")) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      delete axios.defaults.headers.common["Authorization"];
      // Rechargement complet plutôt qu'un push react-router : voir le même
      // correctif dans components/Header.js (retour arrière après déconnexion).
      window.location.href = "/login";
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setPasswordError("");

    if (passwords.newPassword !== passwords.confirmNewPassword) {
      setPasswordError("❌ Les mots de passe ne correspondent pas !");
      return;
    }

    if (passwords.newPassword.length < 8) {
      setPasswordError("❌ Le mot de passe doit avoir au moins 8 caractères !");
      return;
    }

    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const url = `${API_BASE_URL.replace(/\/+$/, "")}/users/change_password.php`;

      const response = await axios.post(
        url,
        {
          current_password: passwords.currentPassword,
          new_password: passwords.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success) {
        alert("✅ Mot de passe changé avec succès ! Vous allez être déconnecté.");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user");
        delete axios.defaults.headers.common["Authorization"];
        navigate("/login");
      } else {
        setPasswordError(
          response.data?.message ||
            "❌ Échec du changement de mot de passe. Réessayez."
        );
      }
    } catch (error) {
      console.error("Erreur changement mot de passe:", error);

      if (error.response?.data?.message) {
        setPasswordError(`❌ ${error.response.data.message}`);
      } else {
        setPasswordError("❌ Une erreur s'est produite. Réessayez plus tard.");
      }
    }
  };

  const handleAvatarUpload = async (e) => {
    const file = e.target.files?.[0];
    
    if (!file) return;

    e.target.value = '';
    setAvatarError("");
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    
    if (!validTypes.includes(file.type)) {
      alert('Format non supporté. Utilisez JPG, PNG ou GIF.');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert('Fichier trop volumineux (max 5 Mo)');
      return;
    }

    const formData = new FormData();
    formData.append("avatar", file);

    try {
      setAvatarUploading(true);
      const url = `${API_BASE_URL.replace(/\/+$/, "")}/users/upload_avatar.php`;

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data?.success) {
        const newAvatarUrl = response.data.avatar_url;
        
        setUserInfo((prev) => ({
          ...prev,
          avatarUrl: newAvatarUrl,
        }));
        
        alert("✅ Photo de profil mise à jour !");
        
        try {
          const stored = localStorage.getItem("user");
          if (stored) {
            const u = JSON.parse(stored);
            u.avatar = newAvatarUrl;
            u.avatarUrl = newAvatarUrl;
            u.avatar_url = newAvatarUrl;
            u.avatar_path = response.data.avatar_path;
            localStorage.setItem("user", JSON.stringify(u));
            
            window.dispatchEvent(new CustomEvent('avatarUpdated', {
              detail: { avatarUrl: newAvatarUrl }
            }));
          }
        } catch (e) {
          console.error("Erreur mise à jour localStorage:", e);
        }
      } else {
        setAvatarError(
          response.data?.message ||
            "Impossible de mettre à jour la photo de profil."
        );
      }
    } catch (err) {
      console.error("Erreur upload avatar:", err);
      
      if (err.response?.status === 413) {
        setAvatarError("Fichier trop volumineux (max 5 Mo)");
      } else if (err.response?.data?.message) {
        setAvatarError(err.response.data.message);
      } else if (err.code === 'ERR_NETWORK') {
        setAvatarError("Erreur réseau. Vérifiez votre connexion.");
      } else {
        setAvatarError("Erreur technique lors de l'upload de la photo.");
      }
    } finally {
      setAvatarUploading(false);
    }
  };

  return (
    <Layout>
      <div className="pagetitle">
        <h1 style={{ color: COLORS.primary, fontWeight: '600' }}>Mon Profil</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/dashboard" style={{ color: COLORS.primary }}>Tableau de bord</a>
            </li>
            <li className="breadcrumb-item active" style={{ color: COLORS.secondary }}>Profil</li>
          </ol>
        </nav>
      </div>

      <section className="section profile">
        {serverError && (
          <div className="alert alert-danger alert-dismissible fade show mb-4" style={{ 
            backgroundColor: '#ffebee',
            borderColor: COLORS.danger,
            color: '#c62828',
            borderRadius: '8px',
            borderLeft: `4px solid ${COLORS.danger}`
          }}>
            <div className="d-flex align-items-center">
              <i className="bi bi-exclamation-triangle me-2"></i>
              <div className="flex-grow-1">{serverError}</div>
              <button 
                type="button" 
                className="btn-close" 
                onClick={() => setServerError("")}
              ></button>
            </div>
          </div>
        )}

        <div className="row">
          {/* Colonne gauche - Photo de profil */}
          <div className="col-xl-4">
            <div className="card" style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              border: 'none'
            }}>
              <div className="card-body text-center">
                <div className="position-relative mb-3">
                  <img
                    src={getAvatarSrc()}
                    alt="Profile"
                    className="rounded-circle"
                    style={{ 
                      width: 140, 
                      height: 140, 
                      objectFit: "cover",
                      border: `4px solid ${COLORS.lightBg}`
                    }}
                    onError={(e) => {
                      e.target.src = "/assets/img/utilisateur.png";
                    }}
                  />
                  {avatarUploading && (
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded-circle" style={{ 
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      zIndex: 1
                    }}>
                      <div className="spinner-border" style={{ color: COLORS.primary }}></div>
                    </div>
                  )}
                </div>

                <div className="mt-2">
                  <label className="btn btn-outline-primary fw-semibold mb-0">
                    <i className="bi bi-camera me-1"></i> Changer la photo
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleAvatarUpload}
                      disabled={avatarUploading}
                    />
                  </label>
                  {avatarError && (
                    <div className="mt-2 small" style={{ color: COLORS.danger }}>
                      <i className="bi bi-exclamation-triangle me-1"></i>
                      {avatarError}
                    </div>
                  )}
                  <p className="small text-muted mt-2">
                    <i className="bi bi-info-circle me-1"></i>
                    JPG, PNG ou GIF • Max 5 Mo
                  </p>
                </div>

                {loading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border" style={{ color: COLORS.primary }}></div>
                    <p className="mt-3" style={{ color: COLORS.darkText }}>Chargement...</p>
                  </div>
                ) : (
                  <>
                    <h2 className="mt-4" style={{ color: COLORS.primary, fontWeight: '600' }}>
                      {userInfo.nom} {userInfo.prenom}
                    </h2>
                    
                    <p className="text-muted mb-4">
                      <i className="bi bi-envelope me-1"></i>
                      {userInfo.email}
                    </p>

                    <button
                      className="btn btn-outline-danger fw-semibold"
                      onClick={handleLogout}
                      style={{
                        borderRadius: '8px',
                        padding: '10px 24px',
                        width: '100%',
                        maxWidth: '200px'
                      }}
                    >
                      <i className="bi bi-box-arrow-right me-2"></i> Déconnexion
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Colonne droite - Informations et mot de passe */}
          <div className="col-xl-8">
            <div className="card" style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              border: 'none'
            }}>
              <div className="card-body">
                {/* Navigation par onglets avec barre bleue qui bouge */}
                <div className="d-flex mb-4" style={{ borderBottom: `2px solid ${COLORS.lightBg}`, position: 'relative' }}>
                  <button
                    className={`nav-link-btn fw-semibold me-4 ${activeTab === "informations" ? "active" : ""}`}
                    onClick={() => setActiveTab("informations")}
                    style={{
                      color: activeTab === "informations" ? COLORS.primary : COLORS.darkText,
                      border: 'none',
                      padding: '12px 0',
                      backgroundColor: 'transparent',
                      fontSize: '1rem',
                      cursor: 'pointer',
                      position: 'relative'
                    }}
                  >
                    <i className="bi bi-person me-2"></i>
                    Informations
                  </button>
                  
                  <button
                    className={`nav-link-btn fw-semibold ${activeTab === "securite" ? "active" : ""}`}
                    onClick={() => setActiveTab("securite")}
                    style={{
                      color: activeTab === "securite" ? COLORS.primary : COLORS.darkText,
                      border: 'none',
                      padding: '12px 0',
                      backgroundColor: 'transparent',
                      fontSize: '1rem',
                      cursor: 'pointer',
                      position: 'relative'
                    }}
                  >
                    <i className="bi bi-key me-2"></i>
                    Sécurité
                  </button>
                  
                  {/* Barre bleue qui se déplace */}
                  <div 
                    className="tab-indicator"
                    style={{
                      position: 'absolute',
                      bottom: '-2px',
                      left: activeTab === "informations" ? '0' : '124px', // Ajustez selon la largeur du premier onglet
                      width: activeTab === "informations" ? '135px' : '115px', // Ajustez selon la largeur de chaque onglet
                      height: '3px',
                      backgroundColor: COLORS.primary,
                      transition: 'all 0.3s ease',
                      borderRadius: '3px 3px 0 0'
                    }}
                  />
                </div>

                {/* Contenu des onglets */}
                <div className="tab-content">
                  {/* Onglet Informations */}
                  {activeTab === "informations" && (
                    <div className="tab-pane active">
                      {loading ? (
                        <div className="text-center py-5">
                          <div className="spinner-border" style={{ color: COLORS.primary }}></div>
                          <p className="mt-3" style={{ color: COLORS.darkText }}>Chargement...</p>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-md-6 mb-4">
                            <div className="card h-100" style={{ 
                              borderRadius: '8px',
                              border: `1px solid ${COLORS.lightBg}`,
                              boxShadow: 'none'
                            }}>
                              <div className="card-body">
                                <h6 className="card-title mb-3" style={{ color: COLORS.primary, fontWeight: '600' }}>
                                  <i className="bi bi-person-circle me-2"></i>
                                  Identité
                                </h6>
                                <div className="mb-3">
                                  <div className="small text-muted mb-1">Nom complet</div>
                                  <div style={{ color: COLORS.darkText, fontWeight: '500' }}>
                                    <i className="bi bi-person me-2" style={{ color: COLORS.secondary }}></i>
                                    {userInfo.nom} {userInfo.prenom}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="small text-muted mb-1">Email</div>
                                  <div style={{ color: COLORS.darkText, fontWeight: '500' }}>
                                    <i className="bi bi-envelope me-2" style={{ color: COLORS.secondary }}></i>
                                    {userInfo.email}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="small text-muted mb-1">Téléphone</div>
                                  <div style={{ color: COLORS.darkText, fontWeight: '500' }}>
                                    <i className="bi bi-telephone me-2" style={{ color: COLORS.secondary }}></i>
                                    {userInfo.phone || "Non renseigné"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="card h-100" style={{ 
                              borderRadius: '8px',
                              border: `1px solid ${COLORS.lightBg}`,
                              boxShadow: 'none'
                            }}>
                              <div className="card-body">
                                <h6 className="card-title mb-3" style={{ color: COLORS.primary, fontWeight: '600' }}>
                                  <i className="bi bi-info-circle me-2"></i>
                                  À propos
                                </h6>
                                <div className="mb-4">
                                  <div className="small text-muted mb-1">Compte créé le</div>
                                  <div style={{ color: COLORS.darkText, fontWeight: '500' }}>
                                    <i className="bi bi-calendar me-2" style={{ color: COLORS.secondary }}></i>
                                    {new Date().toLocaleDateString('fr-FR')}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="small text-muted mb-1">Dernière mise à jour</div>
                                  <div style={{ color: COLORS.darkText, fontWeight: '500' }}>
                                    <i className="bi bi-clock-history me-2" style={{ color: COLORS.secondary }}></i>
                                    Aujourd'hui
                                  </div>
                                </div>
                                <div className="small text-muted mt-4 pt-3 border-top" style={{ borderColor: COLORS.lightBg }}>
                                  <i className="bi bi-exclamation-circle me-1"></i>
                                  Pour modifier vos informations, contactez l'administrateur
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Onglet Sécurité */}
                  {activeTab === "securite" && (
                    <div className="tab-pane active">
                      <form onSubmit={handlePasswordChange}>
                        <div className="card" style={{ 
                          borderRadius: '8px',
                          border: `1px solid ${COLORS.lightBg}`,
                          boxShadow: 'none'
                        }}>
                          <div className="card-body">
                            <h6 className="card-title mb-4" style={{ color: COLORS.primary, fontWeight: '600' }}>
                              <i className="bi bi-lock me-2"></i>
                              Changer le mot de passe
                            </h6>
                          {/* Champ mot de passe actuel */}
                             <div className="mb-4">
                            <label className="form-label" style={{ color: COLORS.darkText, fontWeight: '500' }}>
                              Mot de passe actuel <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text" style={{ 
                                backgroundColor: COLORS.lightBg,
                                borderColor: '#e0e0e0',
                                color: COLORS.secondary
                              }}>
                                <i className="bi bi-shield-lock"></i>
                              </span>
                              <input
                                type={showPasswords.current ? "text" : "password"}
                                className="form-control"
                                value={passwords.currentPassword}
                                onChange={(e) => setPasswords({...passwords, currentPassword: e.target.value})}
                                required
                                placeholder="Votre mot de passe actuel"
                              />
                              <button
                                type="button"
                                className="input-group-text"
                                onClick={() => togglePasswordVisibility('current')}
                                style={{
                                  backgroundColor: COLORS.lightBg,
                                  borderColor: '#e0e0e0',
                                  color: COLORS.secondary,
                                  cursor: 'pointer'
                                }}
                              >
                                <i className={`bi bi-eye${showPasswords.current ? '-slash' : ''}`}></i>
                              </button>
                            </div>
                          </div>

                          {/* Champ nouveau mot de passe */}
                          <div className="mb-4">
                            <label className="form-label" style={{ color: COLORS.darkText, fontWeight: '500' }}>
                              Nouveau mot de passe <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text" style={{ 
                                backgroundColor: COLORS.lightBg,
                                borderColor: '#e0e0e0',
                                color: COLORS.secondary
                              }}>
                                <i className="bi bi-plus-circle"></i>
                              </span>
                              <input
                                type={showPasswords.new ? "text" : "password"}
                                className="form-control"
                                value={passwords.newPassword}
                                onChange={(e) => setPasswords({...passwords, newPassword: e.target.value})}
                                required
                                placeholder="Minimum 8 caractères"
                              />
                              <button
                                type="button"
                                className="input-group-text"
                                onClick={() => togglePasswordVisibility('new')}
                                style={{
                                  backgroundColor: COLORS.lightBg,
                                  borderColor: '#e0e0e0',
                                  color: COLORS.secondary,
                                  cursor: 'pointer'
                                }}
                              >
                                <i className={`bi bi-eye${showPasswords.new ? '-slash' : ''}`}></i>
                              </button>
                            </div>
                            <div className="form-text mt-1" style={{ color: '#6c757d', fontSize: '0.85rem' }}>
                              <i className="bi bi-info-circle me-1"></i>
                              Doit contenir au moins 8 caractères
                            </div>
                          </div>

                          {/* Champ confirmation mot de passe */}
                          <div className="mb-4">
                            <label className="form-label" style={{ color: COLORS.darkText, fontWeight: '500' }}>
                              Confirmer le mot de passe <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text" style={{ 
                                backgroundColor: COLORS.lightBg,
                                borderColor: '#e0e0e0',
                                color: COLORS.secondary
                              }}>
                                <i className="bi bi-check-lg"></i>
                              </span>
                              <input
                                type={showPasswords.confirm ? "text" : "password"}
                                className="form-control"
                                value={passwords.confirmNewPassword}
                                onChange={(e) => setPasswords({...passwords, confirmNewPassword: e.target.value})}
                                required
                                placeholder="Retapez le nouveau mot de passe"
                              />
                              <button
                                type="button"
                                className="input-group-text"
                                onClick={() => togglePasswordVisibility('confirm')}
                                style={{
                                  backgroundColor: COLORS.lightBg,
                                  borderColor: '#e0e0e0',
                                  color: COLORS.secondary,
                                  cursor: 'pointer'
                                }}
                              >
                                <i className={`bi bi-eye${showPasswords.confirm ? '-slash' : ''}`}></i>
                              </button>
                            </div>
                          </div>

                            {passwordError && (
                              <div className="alert alert-danger mt-3" style={{ 
                                backgroundColor: '#ffebee',
                                borderColor: COLORS.danger,
                                color: '#c62828',
                                borderRadius: '8px'
                              }}>
                                <i className="bi bi-exclamation-triangle me-2"></i>
                                {passwordError}
                              </div>
                            )}

                            <div className="d-flex gap-3 mt-4">
                              <button 
                                type="submit" 
                                className="btn btn-primary fw-semibold"
                                style={{
                                  borderRadius: '8px',
                                  padding: '10px 24px'
                                }}
                              >
                                <i className="bi bi-check-circle me-2"></i>
                                Changer le mot de passe
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-secondary fw-semibold"
                                onClick={() => {
                                  setPasswords({
                                    currentPassword: "",
                                    newPassword: "",
                                    confirmNewPassword: "",
                                  });
                                  setPasswordError("");
                                }}
                                style={{
                                  borderRadius: '8px',
                                  padding: '10px 24px'
                                }}
                              >
                                <i className="bi bi-x-circle me-2"></i>
                                Annuler
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .btn:focus,
        .form-control:focus {
          outline: none;
          box-shadow: 0 0 0 0.2rem rgba(30, 136, 200, 0.25);
        }
        
        .form-control:focus {
          border-color: ${COLORS.secondary};
        }
        
        .nav-link-btn {
          transition: all 0.3s ease;
        }
        
        .nav-link-btn:hover:not(.active) {
          color: ${COLORS.primary} !important;
        }
        
        .nav-link-btn.active {
          color: ${COLORS.primary} !important;
        }
        
        @media (max-width: 768px) {
          .card {
            border-radius: 0 !important;
          }
          
          .d-flex.gap-3 {
            flex-direction: column;
          }
          
          .btn {
            width: 100%;
            margin-bottom: 8px;
          }
          
          .d-flex.mb-4 {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .nav-link-btn {
            margin-bottom: 10px;
            margin-right: 0 !important;
            padding: 10px 0 !important;
          }
          
          .tab-indicator {
            display: none; /* Cache l'indicateur sur mobile pour simplifier */
          }
        }
      `}</style>
    </Layout>
  );
};

export default ProfilePage;